<template>
	<div class="tab-pane fade active show" id="description">
		<div class="description-whole-container">
			<div class="desc-p u-s-m-b-26" v-html="selectedProduct.product_desc"></div>
		</div>
	</div>
</template>

<script>
	import {publicPath} from "../../../../../vue.config";
	import {mapGetters} from "vuex";
	export default {
		computed: {...mapGetters("products", ["selectedProduct"])},
		data() {
			return {
				publicPath: publicPath,
				html: "<h1>HimanshuRhia</h1>",
			};
		},
	};
</script>

<style></style>
